import React from 'react';
import styled from 'styled-components';

import { messages } from './messages';
import { OrganizationSelectorView } from './organization-selector-view';
// import Button from '@atlaskit/button';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import { N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';

export type OrganizationSelectorModalProps = {
  readonly isOpen: boolean;

  readonly userName: string;
  readonly userEmail: string;
  readonly avatarSrc?: string;

  readonly organizations: string[];
  readonly onNewOrganizationSelected: () => void;
  readonly onOrganizationSelected: (organization: string) => void;
  readonly onOrganizationChanged?: () => void;
  readonly onSwitchAccountClick: () => void;
  readonly onModalClose?: () => void;
};
const text = { ...messages };
export const OrganizationSelectorModal = (
  props: OrganizationSelectorModalProps
) => {
  const {
    userName,
    userEmail,
    avatarSrc,
    isOpen,
    organizations,
    onNewOrganizationSelected,
    onOrganizationSelected,
    onSwitchAccountClick,
    onOrganizationChanged = () => {},
    onModalClose = () => {}
  } = props;

  const onClose = () => {
    onModalClose();
  };

  return (
    <ModalTransition>
      {isOpen && (
        <ModalDialog onClose={onClose} autoFocus={false}>
          <ModalHeader>
            <CloseButton onClick={onClose}>
              <CrossIcon
                label="Close Modal"
                primaryColor={token('color.text.subtle', N500)}
              />
            </CloseButton>
          </ModalHeader>
          <Container>
            <OrganizationSelectorView
              userName={userName}
              userEmail={userEmail}
              avatarSrc={avatarSrc}
              organizations={organizations}
              onNewOrganizationSelected={onNewOrganizationSelected}
              onOrganizationSelected={onOrganizationSelected}
              onSwitchAccountClick={onSwitchAccountClick}
              onCancelClick={onClose}
              onOrganizationChanged={onOrganizationChanged}
            />
          </Container>
        </ModalDialog>
      )}
    </ModalTransition>
  );
};

OrganizationSelectorModal.defaultProps = {
  onModalClose: () => {},
  onOrganizationChanged: () => {}
};

OrganizationSelectorModal.messages = text;

const Container = styled.div`
  margin: 22px 0px;
`;

const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  margin-top: 24px;
  height: 24px;
`;

const CloseButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  margin-bottom: -4px;
`;
